import React from 'react';

interface ArrowLeftIconProps {
  color?: string;
  size?: number;
}

const ArrowLeftIcon: React.FC<ArrowLeftIconProps> = ({ color = 'white', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.9996 12.0002C20.9996 12.2985 20.8811 12.5846 20.6701 12.7955C20.4592 13.0065 20.1731 13.125 19.8748 13.125H6.84263L11.6726 17.9527C11.7772 18.0573 11.8601 18.1814 11.9167 18.3181C11.9733 18.4547 12.0025 18.6012 12.0025 18.7491C12.0025 18.897 11.9733 19.0434 11.9167 19.1801C11.8601 19.3167 11.7772 19.4409 11.6726 19.5454C11.568 19.65 11.4439 19.733 11.3072 19.7896C11.1706 19.8462 11.0241 19.8753 10.8762 19.8753C10.7283 19.8753 10.5819 19.8462 10.4452 19.7896C10.3086 19.733 10.1844 19.65 10.0799 19.5454L3.33095 12.7965C3.2262 12.692 3.14309 12.5679 3.08638 12.4313C3.02968 12.2946 3.00049 12.1481 3.00049 12.0002C3.00049 11.8522 3.02968 11.7057 3.08638 11.569C3.14309 11.4324 3.2262 11.3083 3.33095 11.2038L10.0799 4.45487C10.2911 4.24366 10.5775 4.125 10.8762 4.125C11.1749 4.125 11.4614 4.24366 11.6726 4.45487C11.8838 4.66608 12.0025 4.95254 12.0025 5.25124C12.0025 5.54994 11.8838 5.8364 11.6726 6.04761L6.84263 10.8753H19.8748C20.1731 10.8753 20.4592 10.9938 20.6701 11.2048C20.8811 11.4157 20.9996 11.7018 20.9996 12.0002Z"
      fill={color}
    />
  </svg>
);

export default ArrowLeftIcon;
